const color = {
  //Amarelo
  corAmarela: {
    rgb: "rgb(255, 160, 0)",
    rgb2: "rgb(255, 224, 130)",
    rgb3: "rgb(204, 174, 87)",

    hexa: "#FFA000",
    hexa2: "#FFB300",
    hexa3: "#CCAE57",
  },

  //Azuis
  corPrimaria: {
    rgb: "rgb(0, 138, 201)",
    hexa: "#008AC9",
  },
  corSecundaria: {
    rgb: "rgb(84, 180, 211)",
    hexa: "#54B4D3",
  }, 

  //Verdes
  corVerde: {
    hexa: "#1A7958",
    hexa2: "#28b886",
    hexa3: "#28a745",

    rgb: "rgb(26, 121, 88)",
    rgb2: "rgb(46, 125, 50)",
    rgb3: "rgb(165, 214, 167)",
  },

  //Vermelhos
  corVermelha: {
    rgb: "rgb(244, 67, 54)",
    rgb2: "rgb(255, 205, 210)",
  },

  //Laranjas
  corLaranja: {
    rgb: " rgb(245, 124, 0)",
    rgb2: "rgb(255, 204, 128)",
    rgb3: "rgb(209, 113, 4)",
  },

  //Lima
  corLima: {
    rgb: "rgb(133, 179, 39)",   
    rgb2: "rgb(180, 228, 14)",   
  },

  //Roxo
  corRoxa: {
    hexa: "#6A1B9A",

    rgb: "rgb(106, 27, 154)",
    rgb2: "rgb(206, 147, 216)",
  },

  //Neutras
  cor1: {
    rgb: "rgb(25, 28, 50)",
    hexa: "#191C32",

    rgb2: "rgb(2, 136, 209)",
    rgb3: "rgb(179, 229, 252)",
  },
  cor2: {
    rgb: "rgb(44, 62, 80)",
    hexa: "#2C3E50",
  },
  cor3: {
    rgb: "rgb(245, 245, 245)",
    rgb2: "rgb(224, 224, 224)",
    hexa: "#F5F5F5",
  },
  cor4: {
    rgb: "rgb(68, 68, 68)",
    hexa: "#444444",
  },
  corCinza: {
    rgb: "rgb(114 ,127, 128)",
    rgb2: "rgb(117, 117, 117)",
    rgb3: "rgb(79, 79, 79)",
    rgb4: "rgb(211, 211, 211)",
    hexa: "#727f80",
    hexa2: "#f4f4f4",
  },
  corShadow: {
    rgba: "rgba(0, 0, 0, 0.1)",
    rgba2: "rgba(0, 0, 0, 0.5)",
    hexa: "#333",
  },

  //Prioridades e Estados
  corNormal: {
    rgb: "rgb(50, 99, 174)",
    hexa: "#3263AE",
  },
  corNaoUrgente: {
    rgb: "rgb(133, 179, 39)",
    hexa: "#85b327",
    rgb2: "rgb(180, 228, 14)",
    hexa2: "#B4E40E",
  },
  corPoucoUrgente: {
    rgb: "rgb(26, 121, 88)",
    hexa: "#1A7958",
  },
  corUrgente: {
    rgb: "rgb(228, 116, 17)",
    hexa: "#E47411",
  },
  corCritica: {
    rgb: "rgb(198, 4, 46)",
    rgb2: "rgb(244, 67, 54)",
    hexa: "#F44336",
  },

};

module.exports = {
  color
};